import { render, staticRenderFns } from "./ValueAmount.vue?vue&type=template&id=9279c81c&"
import script from "./ValueAmount.vue?vue&type=script&lang=js&"
export * from "./ValueAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports